import {
  resultImage1,
  resultImage2,
  resultImage3,
  resultImage4,
} from "../../assets/realResultImages";
import essencaLogo from "../../assets/essenca-optimized.png";
import estethicalLogo from "../../assets/estethica-optimized.png";
import getcoLogo from "../../assets/getco-optimized.png";
import metahomeLogo from "../../assets/metahome-optimized.png";
import technohomeLoogo from "../../assets/technohome-optimized.png";


const homeTR = {
  nav: {
    services: "Hizmetler",
    process: "Süreç",
    results: "Sonuçlar",
    pricing: "Fiyatlandırma",
    faq: "SSS",
    contact: "İletişim",
    pages: "Sayfalar",
  },
  seo: {
    title: "QuadroCode | Yazılım Geliştirme Şirketi",
    description:
      "QuadroCode web siteleri, web/mobil uygulamalar ve özel yazılım çözümleri geliştirir. UI/UX, API, entegrasyonlar ve bakım — performans ve ölçeklenebilirlik odaklı.",
  },
  home: {
    hero: {
      badge: "#Yeni Yazılım Ajansı",
      titleLine1: "Yenilik, Üretim, Ölçek —",
      titleLine2: "Vizyonunuz, Kodumuz",
      descriptionLine1:
        "İşinizi büyüten web siteleri, web uygulamaları ve özel yazılımlar geliştiriyoruz.",
      descriptionLine2:
        "Temiz UI/UX, ölçeklenebilir mimari ve güvenilir teslim — basit sitelerden karmaşık platformlara.",
      cta: "Başlayalım",
      checks: ["Web Uygulama Geliştirme", "Web Site & CMS", "Mobil Uygulama Geliştirme"],
    },

    services: {
      titleLine1: "Yazılım Çözümleri,",
      titleLine2: "Ölçeklenebilir Yapıda",
      subtitleLine1:
        "Web sitelerinden özel platformlara — temiz UI/UX, sağlam mimari,",
      subtitleLine2:
        "ve iş büyümesini destekleyen güvenilir teslimat sunuyoruz.",
      cardCta: "Bizimle Konuş",
      sectionCta: "Daha Fazla",
      cards: [
        {
          id: 1,
          variant: "ux",
          title: "UI/UX Tasarım",
          points: [
            "Netlik ve dönüşüm artıran kullanıcı odaklı arayüzler.",
            "Büyüdükçe tutarlılığı koruyan tasarım sistemi.",
            "Tüm cihaz ve ekranlara uygun responsive yapı.",
          ],
        },
        {
          id: 2,
          variant: "webapp",
          title: "Web Uygulama Geliştirme",
          points: [
            "Dashboard, portal ve SaaS uygulamaları için temiz yapı.",
            "Güvenli API’ler ve ölçeklenebilir backend temeli.",
            "Performans odaklı, bakımı kolay kod tabanı.",
          ],
        },
        {
          id: 3,
          variant: "cms",
          title: "Web Site & CMS",
          points: [
            "İlk günden SEO’ya hazır hızlı web siteleri.",
            "Teknik olmayan ekipler için kolay içerik yönetimi.",
            "Gelecekte büyümeyi destekleyen esnek sayfalar.",
          ],
        },
      ],
      extraCards: [
        {
          id: 4,
          variant: "perf",
          title: "Performans Optimizasyonu",
          points: [
            "Core Web Vitals ve UX için hız iyileştirmeleri.",
            "Gereken yerde asset, görsel ve render optimizasyonu.",
            "Yüklenme süresini ve bounce rate’i düşüren pratik çözümler.",
          ],
        },
        {
          id: 5,
          variant: "support",
          title: "Bakım & Destek",
          points: [
            "Sürekli güncellemeler, izleme ve küçük iyileştirmeler.",
            "Net raporlama ve önceliklerle bug fix.",
            "Prod’u bozmadan stabil yayınlar.",
          ],
        },
        {
          id: 6,
          variant: "devops",
          title: "DevOps & Deployment",
          points: [
            "Güvenilir dağıtımlar için CI/CD temeli.",
            "Linux sunucu kurulumu, domain, SSL ve monitoring.",
            "Production hardening ve ortam tutarlılığı.",
          ],
        },
        {
          id: 7,
          variant: "mobile",
          title: "Mobil Uygulama Geliştirme",
          points: [
            "Temiz UX ve native hissi veren cross-platform uygulamalar.",
            "Ölçeklenirken sürdürülebilir kalan düzenli mimari.",
            "Auth, ödeme, bildirim ve mağaza teslimi.",
          ],
        },
        {
          id: 8,
          variant: "api",
          title: "API Entegrasyonu",
          points: [
            "Harici API’ler ve dahili servislerle güvenilir entegrasyon.",
            "Güvenli kimlik doğrulama (JWT/OAuth) ve temiz hata yönetimi.",
            "Stabil veri senkronu, caching ve performans odaklı istekler.",
          ],
        },
        {
          id: 9,
          variant: "ai",
          title: "AI Agent’lar",
          points: [
            "İş akışlarını otomatikleştiren görev odaklı agent’lar.",
            "Tool + API bağlı agent’lar (guardrail + loglama ile).",
            "Gerçek kullanımda ölçeklenecek deploy edilebilir mimari.",
          ],
        },
      ],
    },

    process: {
      titleLine1: "Net Bir Süreç,",
      titleLine2: "Sağlam Teslimat",
      subtitleLine1: "Basit tutuyoruz: hedefi anla, amaçlı tasarla, temiz geliştir,",
      subtitleLine2: "güvenle yayına al — sonra gerçek geri bildirimle iyileştir.",
      cards: [
        {
          number: "01",
          variant: "discover",
          title: "Keşif & Kapsam",
          text: "Hedefleri, kullanıcıyı ve gereksinimleri netleştirir; sürprizleri önlemek için kapsam ve takvim belirleriz.",
        },
        {
          number: "02",
          variant: "design",
          title: "Tasarım & Prototip",
          text: "UI/UX yönünü belirler, temel akışları prototiple doğrularız; erken doğrulama ile hız kazanırız.",
        },
        {
          number: "03",
          variant: "build",
          title: "Geliştirme & Entegrasyon",
          text: "Ölçeklenebilir yapı, temiz API’ler ve iş akışınıza uygun entegrasyonlarla geliştiririz.",
        },
        {
          number: "04",
          variant: "launch",
          title: "Test & Yayın",
          text: "Cihazlar arası test eder, uç durumları çözer, prod için stabil deploy ve performans kontrolleri yaparız.",
        },
        {
          number: "05",
          variant: "grow",
          title: "Destek & İyileştirme",
          text: "Yayından sonra: yeni özellikler, performans iyileştirmeleri ve sürekli destek ile ürünü büyütürüz.",
        },
      ],
    },

    results: {
      titleLine1: "Gerçek İş,",
      titleLine2: "Prod’a Hazır Sonuçlar",
      subtitleLine1: "Pratik çözümler geliştiriyoruz — temiz arayüz, güvenilir işlev,",
      subtitleLine2: "ve işiniz büyüdükçe ölçeklenen sistemler.",
      cta: "İletişime Geç",
      items: [
        {
          id: 1,
          imgURL: resultImage1.src,
          imgSrcSet: resultImage1.srcSet,
          title: "E-Ticaret Altyapısı",
          text: "Hızlı ve responsive mağaza yapısı; net sayfa düzeni ve dönüşüme odaklı deneyim.",
        },
        {
          id: 2,
          imgURL: resultImage2.src,
          imgSrcSet: resultImage2.srcSet,
          title: "Ekip İş Birliği Web Uygulaması",
          text: "Rol bazlı erişim, gerçek zamanlı akışlar ve ölçeklenebilir mimari üzerine kurulu güvenli bir yaklaşım.",
        },
        {
          id: 3,
          imgURL: resultImage3.src,
          imgSrcSet: resultImage3.srcSet,
          title: "Modern UI Yenileme",
          text: "Okunabilirlik, tutarlılık ve cihazlar arası responsive davranışa odaklı UI yaklaşımı.",
        },
        {
          id: 4,
          imgURL: resultImage4.src,
          imgSrcSet: resultImage4.srcSet,
          title: "Marka Tanıtım Sitesi",
          text: "Hizmetleri net gösteren, güven oluşturan ve iletişim taleplerini artıran temiz site yapısı.",
        },
      ],
    },

    pricing: {
      titleLine1: "Esnek Fiyatlandırma,",
      titleLine2: "Kapsamınıza Göre",
      subtitle:
        "Bir başlangıç paketi seçin, özellikler/sayfa sayısı/entegrasyonlar ve süreye göre net teklifi çıkaralım.",
      tabs: ["Aylık", "3 Aylık", "Yıllık"],
      priceSuffix: "başlangıç",
      cta: "Başlayalım",
      note:
        "Nihai fiyat ihtiyaçlara bağlıdır. Kısa bir görüşmeden sonra kapsam, takvim ve net teklif sunuyoruz.",
      plans: [
        {
          id: 1,
          variant: "starter",
          title: "Başlangıç Web Sitesi",
          desc:
            "Yeni işletmeler için: hızlı ve temiz bir site ile lead toplama ve güven oluşturma.",
          priceFrom: "$499",
          features: [
            "Modern responsive tasarım",
            "Temel SEO kurulumu (başlık/meta/yapı)",
            "İletişim bölümü + CTA akışı",
            "Performans dostu asset’ler",
            "Gelecekte genişlemeye uygun yapı",
          ],
        },
        {
          id: 2,
          variant: "business",
          title: "Business Web Sitesi",
          desc:
            "Hizmet şirketleri için: daha fazla bölüm, güçlü içerik yapısı ve entegrasyonlar.",
          priceFrom: "$1,299",
          features: [
            "İçerik ve bölüm stratejisi",
            "Dönüşüm odaklı UX iyileştirmeleri",
            "Entegrasyonlar (WhatsApp, form, email)",
            "On-page SEO temeli",
            "Deploy ve temel prod hazırlığı",
          ],
        },       
        {
          id: 3,
          variant: "mobile",
          title: "Mobil Uygulama",
          desc:
            "Güçlü kullanıcı deneyimi ve backend entegrasyonu gerektiren mobil uygulamalar için.",
          priceFrom: "$2,499",
          features: [
            "iOS ve Android yayın yolu",
            "Temiz mobil UX ve kullanıcı akışları",
            "API/backend entegrasyonuna hazır yapı",
            "Auth, bildirimler ve temel uygulama mantığı",
            "Mağaza yayını desteği",
          ],
        },
         {
          id: 4,
          variant: "custom",
          title: "Özel Yazılım",
          desc:
            "Web uygulamaları, portal/dashboards, otomasyon ve platformlar — backend, roller ve API gerektiren işler.",
          priceFrom: "Teklif",
          features: [
            "Mimari + roadmap planlama",
            "Backend API’ler ve entegrasyonlar",
            "Rol/izin ve güvenli akışlar",
            "Ölçeklenebilir kod tabanı & deploy",
            "Bakım ve iterasyon seçenekleri",
          ],
        },
      ],
    },

    trusted: {
      title: "İş Ortaklarımızın Güveni",
      aria: "Partner logo kaydırma alanı",
      logoAlt: "Partner logosu {n}",
      logos: [
        metahomeLogo,
        essencaLogo,
        technohomeLoogo,
        estethicalLogo,
        getcoLogo,
      ],
    },

    footer: {
      faq: {
        title: "Sık Sorulan Sorular",
        subtitle: "Nasıl çalıştığımız ve ne bekleyebileceğiniz hakkında net cevaplar.",
        cta: "İletişime Geç",
        items: [
          {
            id: 1,
            q: "Bir web sitesi ne kadar sürede yapılır?",
            a: "Genelde 1–3 hafta sürer. Sayfa sayısı, içerik hazırlığı ve geri bildirim hızına göre süre uzayabilir.",
          },
          {
            id: 2,
            q: "Sadece web sitesi değil, özel yazılım da yapıyor musunuz?",
            a: "Evet. Web app, dashboard, portal ve otomasyon geliştiriyoruz — backend, API, rol/izin ve entegrasyonlar dahil.",
          },
          {
            id: 3,
            q: "Mevcut siteyi yeniden tasarlıyor musunuz?",
            a: "Evet. UI/UX, yapı ve performansı iyileştirir; çalışan içerik stratejisini bozmadan ilerleriz.",
          },
          {
            id: 4,
            q: "Bakım ve destek veriyor musunuz?",
            a: "Evet. Güncellemeler, bug fix, iyileştirme ve izleme için ürün ihtiyacına göre destek sunuyoruz.",
          },
          {
            id: 5,
            q: "Siteniz mobil uyumlu ve hızlı mı olur?",
            a: "Evet. Responsive tasarım ve asset optimizasyonu ile cihazlar arası iyi UX ve performans hedefliyoruz.",
          },
          {
            id: 6,
            q: "Fiyatlandırma nasıl yapılıyor?",
            a: "Başlangıç paketinden başlarız, kapsam (sayfa/özellik/entegrasyon/süre) netleşince sabit teklif sunarız.",
          },
        ],
      },

      cta: {
        title: "Projeye QuadroCode ile Başlayın",
        button: "Başlayalım",
      },

      brand: {
        name: "QuadroCode",
        logoAlt: "QuadroCode logosu",
        taglineLine1: "Yenilik, Üretim, Ölçek —",
        taglineLine2: "Vizyonunuz, Kodumuz",
        contactBtn: "İletişim",
      },

      contact: {
        emailLabel: "E-posta",
        phoneLabel: "Telefon",
        email: "",
        phone: "",
        location: "",
        form: {
          title: "Projenizden Bize Bahsedin",
          subtitle: "Projenizin kapsamını, zaman planını veya fikrinizi form üzerinden paylaşın; ekibimiz sizinle iletişime geçecektir.",
          submit: "Talep Gönder",
          success: "Talebiniz başarıyla gönderildi.",
          error: "Bir sorun oluştu. Lütfen tekrar deneyin.",
          sending: "Talep gönderiliyor...",
          emailIntro: "Web sitesinden yeni proje talebi.",
          defaultSubject: "Yeni proje talebi",
          fields: {
            name: "Ad",
            email: "E-posta",
            subject: "Konu",
            message: "Mesaj",
          },
          placeholders: {
            name: "Adınız",
            email: "you@company.com",
            subject: "Proje kapsamı",
            message: "Neye ihtiyacınız olduğunu yazın.",
          },
        },
      },

      socialsAria: "Sosyal bağlantılar",
      socials: {
        whatsapp: "",
        instagram: "",
        linkedin: "",
        x: "",
      },

      links: {
        col1: {
          title: "Menü",
          items: [
            { label: "Hizmetler", href: "#services" },
            { label: "Süreç", href: "#process" },
            { label: "Sonuçlar", href: "#results" },
            { label: "Fiyatlandırma", href: "#pricing" },
          ],
        },
        col2: {
          title: "Şirket",
          items: [
            { label: "SSS", href: "#faq" },
            { label: "İletişim", href: "#contact" },
          ],
        },
        col3: {
          title: "Hizmetler",
          items: [
            { label: "UI/UX Tasarım", href: "#services" },
            { label: "Web Geliştirme", href: "#services" },
            { label: "Özel Yazılım", href: "#services" },
          ],
        },
      },

      copyright:
        "Copyright © {year} QuadroCode — Yazılım Geliştirme Şirketi",
    },
  },
};

export default homeTR;

